import { Component, Input, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs';
import { SubscriberService } from 'src/app/services/manager/subscriber.service';
import { ModalService } from 'src/app/services/base/modal.service';
import { ConvertContactComponent } from '../convert-contact/convert-contact.component';

@Component({
  selector: 'app-google-contact',
  templateUrl: './google-contact.component.html',
  styleUrls: ['./google-contact.component.scss'],
  standalone: false,
})
export class GoogleContactComponent implements OnInit, OnDestroy {

  @Input() search = "";
  @Input() showSearch = true;



  destroy = new Subject();

  private searchSubject = new Subject<string>();

  searchTerm = '';

  dataList: any;
  dataListFiltered: any;

  constructor(
    private sub: SubscriberService,
    private modal: ModalService
  ) {}

  ngOnInit() {
    this.searchSubject.pipe(
      takeUntil(this.destroy),
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe(term => {
      this.searchTerm = term;
      this.filterProducts();
    });

    this.subscribe();
  }

  subscribe() {
    this.sub.googleContactList.pipe(takeUntil(this.destroy)).subscribe((data) => {
      this.dataList = data;
      this.filterProducts();
    });
  }


    ngOnChanges(changes: SimpleChanges) {
      if (changes['search']) {
        this.handleDataChange(changes['search'].currentValue);
      }
    }

    handleDataChange(newValue: string) {
        this.searchSubject.next(newValue);
    }



  onSearchChange(event: any) {
    const inputValue = event.target.value;
    this.searchSubject.next(inputValue);
  }

  filterProducts() {
    if(this.dataList == null || this.dataList == undefined) {
      return;
    }

    if (this.searchTerm) {
      const searchTermLower = this.searchTerm.toLowerCase().trim();
      const flatFields = ['companyName', 'displayName', 'email', 'phone'];
      const addressFields = ['street', 'zip', 'city'];

      this.dataListFiltered = this.dataList.filter((item: any) => {
        const flatMatch = flatFields.some((field) => {
          const value = item?.[field];
          return value != null && value.toString().toLowerCase().includes(searchTermLower);
        });
        if (flatMatch) return true;

        return addressFields.some((field) => {
          const value = item?.address?.[field];
          return value != null && value.toString().toLowerCase().includes(searchTermLower);
        });
      });
    } else {
      this.dataListFiltered = this.dataList;
    }
  }

  trackByContactId(index: number, item: any): string {
    return item?.id || item?.email || item?.displayName || index.toString();
  }

  async convertContact(contact: any) {
    await this.modal.openModal(ConvertContactComponent, { google: contact, lexware: null });
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.complete();
  }

}
